import { styled } from '@mui/system';
import MuiAppBar from '@mui/material/AppBar';
import muiPropForwarding from 'styles/helpers/muiPropForwarding';

const StyledAppBar = styled(MuiAppBar, {
  shouldForwardProp: muiPropForwarding('ownState')
})(({ theme, ownState }) => {
  const ownMuiAppBarRootStyles = ownState?.appBar?.(theme) ?? {};

  return {
    '&.MuiAppBar-root': {
      ...ownMuiAppBarRootStyles
    }
  };
});

export default StyledAppBar;
